import React, { useEffect, useRef, useState } from "react";

const AutoScrollContainer = React.forwardRef(({ children, onScroll, ...props }, ref) => {
    const [isDragging, setIsDragging] = useState(false);
    const [mousePosition, setMousePosition] = useState(null);
    const scrollSpeed = 30;
    const scrollThreshold = 100;
    const internalRef = useRef(null);


    const containerRef = ref || internalRef;

    useEffect(() => {
        const handleMouseMove = (e) => {
            if (isDragging) {
                setMousePosition({ x: e.clientX, y: e.clientY });
            }
        };

        window.addEventListener('mousemove', handleMouseMove);
        return () => window.removeEventListener('mousemove', handleMouseMove);
    }, [isDragging]);

    useEffect(() => {
        if (!isDragging || !mousePosition || !containerRef.current) return;

        const container = containerRef.current;
        const rect = container.getBoundingClientRect();

        // Verificar se estamos perto da borda superior ou inferior
        const isNearTop = mousePosition.y - rect.top < scrollThreshold;
        const isNearBottom = rect.bottom - mousePosition.y < scrollThreshold;

        if (!isNearTop && !isNearBottom) return;

        const scrollInterval = setInterval(() => {
            if (isNearTop) {
                container.scrollTop -= scrollSpeed;
            } else if (isNearBottom) {
                container.scrollTop += scrollSpeed;
            }
        }, 5); // ~60fps

        return () => clearInterval(scrollInterval);
    }, [isDragging, mousePosition, containerRef]);

    useEffect(() => {
        const handleDragStart = () => setIsDragging(true);
        const handleDragEnd = () => setIsDragging(false);

        window.addEventListener('dragstart', handleDragStart);
        window.addEventListener('dragend', handleDragEnd);

        return () => {
            window.removeEventListener('dragstart', handleDragStart);
            window.removeEventListener('dragend', handleDragEnd);
        };
    }, []);

    const handleScroll = (e) => {
        if (onScroll) {
            onScroll(e);
        }
    };

    return (
        <div
            ref={containerRef}
            onScroll={handleScroll}
            {...props}
        >
            {children}
        </div>
    );
});


export default AutoScrollContainer;